import Table from "./DataTable";
import { Pagination } from "./Pagination";
interface Props {
  columns: (
    | {
        path: string;
        label: string | null;
        key: string | null;
        // eslint-disable-next-line no-empty-pattern
        content: ({}) => Element | null;
      }
    | any
  )[];
  data: {}[];
  onRowClick?: (item: any) => void;
  isTableDataLoading?: boolean;
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
}

export const TableWithPagination = ({
  columns,
  data,
  onRowClick,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
}: Props) => {
  return (
    <>
      <Table
        isTableDataLoading={isTableDataLoading}
        columns={columns}
        data={data}
        onRowClick={onRowClick}
      ></Table>
      {data?.length > 0 && (
        <Pagination
          onPageChange={onPageChange}
          isTableDataLoading={isTableDataLoading}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          totalPages={Math.ceil(totalData / rowsPerPage)}
        />
      )}
    </>
  );
};
